import { render, staticRenderFns } from "./role-badge.vue?vue&type=template&id=70a289d6&"
import script from "./role-badge.vue?vue&type=script&lang=ts&"
export * from "./role-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a289d6')) {
      api.createRecord('70a289d6', component.options)
    } else {
      api.reload('70a289d6', component.options)
    }
    module.hot.accept("./role-badge.vue?vue&type=template&id=70a289d6&", function () {
      api.rerender('70a289d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/users/components/role-badge.vue"
export default component.exports